import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { PersistenceEffects } from './persistence.effects';
import { QueueEffects } from './queue.effects';
import { ReadingListEditService } from './reading-list-edit.service';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([QueueEffects, PersistenceEffects]),
  ],
  providers: [ReadingListEditService],
})
export class QueueEffectsModule {}
